import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import BotPage from './BotPage';
import AdminGateLayout from './admin/AdminGateLayout';
import AdminBotPicker from './admin/AdminBotPicker';
import AdminDesignerPage from './admin/AdminDesignerPage';
import { getDefaultRedirectPath, getDefaultRedirectPathForDomain } from '../config/getBotConfig';
import { AuthCallback } from '../services/auth/authService';

function RootRedirect() {
  const to = getDefaultRedirectPath();
  return <Navigate to={to} replace />;
}

function DomainRedirect() {
  const { domainName } = useParams();
  const to = getDefaultRedirectPathForDomain(domainName);
  if (!to) return <Navigate to="/" replace />;
  return <Navigate to={to} replace />;
}

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/authenticated" element={<AuthCallback />} />
        <Route path="/admin" element={<AdminGateLayout />}>
          <Route index element={<AdminBotPicker />} />
          <Route path=":domainName/:botName" element={<AdminDesignerPage />} />
        </Route>
        <Route path="/:domainName" element={<DomainRedirect />} />
        <Route path="/:domainName/:botName" element={<BotPage />} />
      </Routes>
    </>
  );
}
